module.exports = __webpack_public_path__ + "static/media/400137_01.6fff9e11.png";